import ClientPortalSetting from "./client-portal-setting/ClientPortalSetting";
import EditProfile from "../edit-profile/EditProfile";
import AccountSetting from "./account-setting/AccountSetting";
import PracticeSetting from "./practice-setting/PracticeSetting";
import PatientAnalytics from "./patient-analytics/PatientAnalytics";
import Integration from "./integration/Integration";
import BillingSetting from "./billing-setting/BillingSetting";
import AISetting from "./ai-setting/AISetting";
import Directory from "./directory/Directory";
import NotificationSetting from "./notifications/Notifications";
import TelehealthSetting from "./telehealth/Teleahealth";

type SvgComponent = React.FunctionComponent<React.SVGProps<SVGSVGElement>>;

export type SettingsRoute = {
  path: string;
  name: string;
  component: () => JSX.Element | null;
  exact: boolean;
  icon?: SvgComponent /*JSX.Element*/;
  featureName?: Feature; // only necessary if route has feature gating
  roleFeatureName?: string;
};

export const SETTINGS_ROUTES: SettingsRoute[] = [
  {
    path: "my-profile",
    name: "My Profile",
    component: EditProfile,
    exact: true,
    roleFeatureName: "profileTab",
  },
  {
    path: "practice-setting",
    name: "Practice Setting",
    component: PracticeSetting,
    exact: true,
    roleFeatureName: "practiceSetting",
  },
  {
    path: "directory",
    name: "Directory",
    component: Directory,
    exact: true,
    roleFeatureName: "directory",
  },
  {
    path: "client-portal",
    name: "Client Portal",
    component: ClientPortalSetting,
    exact: true,
    featureName: "full-settings",
    roleFeatureName: "clientPortalTab",
  },
  {
    path: "billing",
    name: "Billing",
    component: BillingSetting,
    exact: true,
    featureName: "full-settings",
    roleFeatureName: "billingTab",
  },
  {
    path: "patient-analytics",
    name: "Patient Analytics",
    component: PatientAnalytics,
    exact: true,
    featureName: "full-settings",
    roleFeatureName: "patientAnalyticsTab",
  },
  {
    path: "account",
    name: "Account",
    component: AccountSetting,
    exact: true,
    roleFeatureName: "accountTab",
  },
  {
    path: "notifications",
    name: "Notifications",
    component: NotificationSetting,
    exact: true,
    roleFeatureName: "notificationsTab",
  },
  {
    path: "integrations",
    name: "Integrations",
    component: Integration,
    exact: true,
    featureName: "full-settings",
    roleFeatureName: "integrationsTab",
  },
  {
    path: "ai-setting",
    name: "AI Settings",
    component: AISetting,
    exact: true,
    featureName: "ai-settings",
    roleFeatureName: "aiSettingsTab",
  },
  {
    path: "telehealth",
    name: "Telehealth",
    component: TelehealthSetting,
    exact: true,
    roleFeatureName: "telehealthTab",
  },
];
